export const ONBOARDING_TO_SUBSCRIPTION_EVENT = 'onboardingToSubscription';

export const emitOnboardingToSubscription = (): void => {
  try {
    window.dispatchEvent(new CustomEvent(ONBOARDING_TO_SUBSCRIPTION_EVENT));
  } catch (error) {
    console.error('Error emitting onboardingToSubscription event:', error);
  }
};
